import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'

class SuccessModal {
    
    /**
     * Construct module
     * @param container
    */
    constructor(container) {
        
        /**
         * Container jQuery object
         * @type {object}
        */
        this.container = container
        
        /**
         * Title jQuery object
         * @type {object}
        */
        this.title = jQuery('#success-modal-title')
        
        /**
         * Content jQuery object
         * @type {array}
        */
        this.content = jQuery('#success-modal-content')
        
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        if (typeof success == 'object') {
            this.showModal(success)
        }
    }
    
    /**
     * Show modal
     * @params params
    */
    showModal(params) {
        this.title.text(params.hasOwnProperty('title') ? params.title : successModalDefaultTitle)
        this.content.html('<p class="m-0">' + params.message + '</p>')
        this.container.modal('show')
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Run component
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Show confirmation
        EventBus.subscribe('success', this.showModal.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let container = jQuery('#success-modal')
    
    if (container.length > 0) {
        new SuccessModal(container)
    }
    
})

export default SuccessModal